const FORM_STEPS_INITIAL = 1
const FORM_STEPS_AMOUNT = 6

export default {
  namespaced: true,
  state: {
    hasAcceptedTerms: false,
    currentStep: FORM_STEPS_INITIAL,
    currentStepValidate: null,
  },
  mutations: {
    clear(state) {
      state.currentStep = FORM_STEPS_INITIAL
      state.hasAcceptedTerms = false
      state.currentStepForm = null
    },
    setCurrentStepValidate(state, payload) {
      state.currentStepValidate = payload
    },
    setAcceptedTerms(state, payload = true) {
      state.hasAcceptedTerms = payload
    },
  },
  actions: {
    async goToNextStep({ dispatch, state }) {
      try {
        if (state.currentStep === FORM_STEPS_AMOUNT) return
        if (typeof state.currentStepValidate === 'function') await state.currentStepValidate()
        dispatch('setCurrentStep', state.currentStep + 1)
      } catch (e) {
        //
      }
    },
    async goToPrevStep({ dispatch, state }) {
      try {
        if (state.currentStep === FORM_STEPS_INITIAL) return
        dispatch('setCurrentStep', state.currentStep - 1)
      } catch (e) {
        //
      }
    },
    async goToStep({ dispatch, state }, step) {
      try {
        if (step < FORM_STEPS_INITIAL) return
        if (step > FORM_STEPS_AMOUNT) return
        if (state.currentStep - step < -1) return 

        if (state.currentStep - step < 1 && typeof state.currentStepValidate === 'function') await state.currentStepValidate()

        dispatch('setCurrentStep', step)
      } catch (e) {
        //
      }
    },
    async setCurrentStep({ dispatch, state }, step = 1) {
      try {
        if (step === 6) {
          dispatch('teamRegistration/parseTeamsFromCategories', null, { root: true })
          await dispatch('teamRegistration/submit', null, { root: true })
        }
        state.currentStep = step
        window.scrollTo(0, 0)
      } catch (e) {
        // 
      }
    },
  },
}
